import axios from "axios";
import { baseApiUrl, httpRequest, getHttpHeaders } from "./ApiUtils";

const offertypeApiUrl = `${baseApiUrl}/api/OfferTypes`;

export async function GetOfferTypeById(id) {
  return await httpRequest(fetchOfferTypeById.bind(this, id));
}

const fetchOfferTypeById = async (id) => {
  return await axios.get(`${offertypeApiUrl}/${id}`);
}

export const getOffersStatistics = async (month, year) => {
  return await httpRequest(fetchOffersStatistics.bind(this, month, year));
}

const fetchOffersStatistics = async (month, year) => {
  let config = getHttpHeaders();
  return await axios.get(`${offertypeApiUrl}/Statistics?Month=${month}&Year=${year}`, config);
}

export const getOfferTypes = async () => {
  return await httpRequest(fetchOfferTypes.bind(this));
}

export const getActiveOfferTypes = async () => {
  let config = getHttpHeaders();
  return await axios.get(`${offertypeApiUrl}/Active`, config);
}

const fetchOfferTypes = async () => {
  let config = getHttpHeaders();
  return await axios.get(`${offertypeApiUrl}`, config);
}

export const updateOfferType = async (id) => {
  return await httpRequest(putOfferType.bind(this, id));
}

const putOfferType = async (id) => {
  let config = getHttpHeaders();
  return await axios.put(`${offertypeApiUrl}/${id}`, null, config);
}